import { REMOVER_NOTA_FISCAL } from '../types'

export default function removerNotaFiscal (notaFiscal) {
  return {
    type: REMOVER_NOTA_FISCAL,
    payload: notaFiscal
  }
}
